import { REACT_COMPONENT_MAP } from '@/constants/react/component-constants';

export const reactComponentMixin = {
  data() {
    return {
      reactComponent: null,
    };
  },

  computed: {
    id() {
      return this.$options.name;
    },
  },

  methods: {
    navigate(path) {
      this.$router.push(path);
    },

    async mountReactComponent(componentName, props = {}) {
      try {
        const componentImporter = REACT_COMPONENT_MAP[componentName];

        if (!componentImporter) {
          throw new Error(`React component '${componentName}' not found.`);
        }

        const { mount } = await componentImporter();
        const reactComponent = this.$refs.reactRef;

        if (reactComponent) {
          const defaultProps = {
            apiBaseUrl: process.env.VUE_APP_API_URL,
            navigate: this.navigate,
            ...props,
          };

          this.reactComponent = mount(reactComponent, defaultProps);
        } else {
          console.error(`React container with ID '${componentName}' is missing.`);
        }
      } catch (error) {
        console.error(`Error loading React component '${componentName}':`, error);
      }
    },

    async unmountReactComponent() {
      try {
        if (this.reactComponent && typeof this.reactComponent.unmount === 'function') {
          await this.reactComponent.unmount();
        }
      } catch (error) {
        console.error('Error unmounting React component:', error);
      }
    },
  },

  async beforeDestroy() {
    await this.unmountReactComponent();
  },
};
